interface PagedItems<TItem> {
  readonly items: readonly TItem[]
  readonly lastPage: number
}

/** Fetches pages from 1 through the reported last page, stopping early on an empty page. */
export const collectPagedItems = async <TItem>(
  fetchPage: (page: number) => Promise<PagedItems<TItem>>
): Promise<TItem[]> => {
  const collected: TItem[] = []
  for (let page = 1; ; page += 1) {
    const { items, lastPage } = await fetchPage(page)
    if (items.length === 0) break
    collected.push(...items)
    if (page >= lastPage) break
  }
  return collected
}
